/** One run of label text, flagged as matching the query or not. */
export interface HighlightSegment {
  text: string;
  match: boolean;
}

/** Escape a user string so it can be used literally inside a RegExp. */
function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Split `label` into segments around every case-insensitive occurrence of
 * `query`, so the search row can bold the matched runs (e.g. "Presidential
 * **Election** Winner"). A blank query returns the whole label as a single
 * unmatched segment.
 */
export function splitHighlight(label: string, query: string): HighlightSegment[] {
  const needle = query.trim();
  if (!needle) return [{ text: label, match: false }];

  const re = new RegExp(`(${escapeRegExp(needle)})`, 'ig');
  return label
    .split(re)
    .filter((part) => part.length > 0)
    .map((part) => ({ text: part, match: part.toLowerCase() === needle.toLowerCase() }));
}
